import React from 'react';
import { Checkbox, List } from 'antd';

const CheckboxGroup = (props) => {
  const {
    size = 'small',
    column = 3,
    gutter = 8,
    options,
    renderItem,
    ...restProps
  } = props;

  return (
    <Checkbox.Group {...restProps}>
      <List
        size={size}
        grid={{ gutter, column }}
        dataSource={options}
        renderItem={(option) => (
          <List.Item style={{ marginBottom: gutter }}>
            {renderItem(option)}
          </List.Item>
        )}
      />
    </Checkbox.Group>
  );
};

export default CheckboxGroup;
